<template>
  <!-- <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.50091 16.0002L8.50092 8.50016M5.21886 10.8439L8.50056 7.5622L11.7823 10.8439M13.4609 14.1248C15.018 12.7505 16 10.7398 16 8.49976C16 4.35762 12.6421 0.999756 8.5 0.999756C4.35787 0.999755 1 4.35762 1 8.49976C1 10.7398 1.98204 12.7505 3.53908 14.1248"
            stroke="#277FAF"
            stroke-width="2"
        />
    </svg> -->
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 11V14.5556C16 15.0271 15.8127 15.4793 15.4793 15.8127C15.1459 16.1461 14.6937 16.3334 14.2222 16.3334H1.77778C1.30628 16.3334 0.854097 16.1461 0.520699 15.8127C0.187301 15.4793 0 15.0271 0 14.5556V11M3.55556 6.5556L8 11M8 11L12.4444 6.5556M8 11V0.333374"
      stroke="#F2F2F2"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'UploadImgIcon',
}
</script>

<style lang="scss" scoped>
svg {
  path {
    fill: transparent !important;
  }
}
</style>
